import { useQuery } from "@tanstack/react-query";

import { LS_KEYS } from "@core/core.constants";

import { fetchiosHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type { TenantConfig } from "./tenant.types";

const getTenantConfig = async ({ signal }: { signal: AbortSignal }) => {
  const tenant =
    window.tenant === "kuriosity"
      ? localStorage.getItem(LS_KEYS.TENANT) || "kuriosity"
      : window.tenant;

  const response = await fetchiosHttp.get<TenantConfig>(
    `${import.meta.env.VITE_APP_FRONT_URL_PREFIX}/${tenant}/config.json?v=${__APP_VERSION__}`,
    { signal },
  );

  return response.data;
};

export const useGetTenantConfig = () =>
  useQuery<TenantConfig>({
    queryKey: [QUERY_KEYS.TENANT_CONFIG, window.tenant],
    queryFn: getTenantConfig,
    retry: 3,
  });
